import { useMemo } from "react";

export const useAlignment = (alignment: string, S: { [key: string]: string }) => {
    const alignmentClass = useMemo(() => {
        switch (alignment) {
            case "ALIGNMENT_LEFT":
                return S.alignmentLeft;
        }
    }, [alignment, S]);

    return {
        alignmentClass,
    };
};
